(function () {
  'use strict';

  function syncSection(section) {
    var columns = section.querySelectorAll('.faq-section__column');
    if (columns.length < 2) return;

    var cols = [];
    for (var i = 0; i < columns.length; i++) {
      var summaries = columns[i].querySelectorAll('.faq-section__item details > summary');
      cols.push(Array.prototype.slice.call(summaries));
    }

    for (var c = 0; c < cols.length; c++) {
      for (var s = 0; s < cols[c].length; s++) {
        cols[c][s].style.minHeight = '';
      }
    }

    if (window.innerWidth < 750) return;

    var rowCount = 0;
    for (var j = 0; j < cols.length; j++) {
      if (cols[j].length > rowCount) rowCount = cols[j].length;
    }

    for (var r = 0; r < rowCount; r++) {
      var rowSummaries = [];
      for (var k = 0; k < cols.length; k++) {
        if (cols[k][r]) rowSummaries.push(cols[k][r]);
      }
      if (rowSummaries.length < 2) continue;

      var max = 0;
      for (var m = 0; m < rowSummaries.length; m++) {
        var h = rowSummaries[m].offsetHeight;
        if (h > max) max = h;
      }
      for (var n = 0; n < rowSummaries.length; n++) {
        rowSummaries[n].style.minHeight = max + 'px';
      }
    }
  }

  function syncAll() {
    var sections = document.querySelectorAll('.faq-section');
    for (var i = 0; i < sections.length; i++) {
      syncSection(sections[i]);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', syncAll);
  } else {
    syncAll();
  }

  window.addEventListener('load', syncAll);

  if (document.fonts && document.fonts.ready) {
    document.fonts.ready.then(syncAll);
  }

  var resizeTimer;
  window.addEventListener('resize', function () {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(syncAll, 100);
  });

  document.addEventListener('shopify:section:load', syncAll);
  document.addEventListener('shopify:section:unload', syncAll);
  document.addEventListener('shopify:section:reorder', syncAll);
  document.addEventListener('shopify:block:select', syncAll);
})();
